import { Preferences } from '@capacitor/preferences'
import { useQueryClient } from '@tanstack/react-query'
import dayjs from 'dayjs'
import { encodeBase64 } from '../../../components/mainTabs/WebAppLayout'
import { trpc } from '../../../modules/trpc'

const useBankAuth = () => {
	const utils = trpc.useContext()
	const queryClient = useQueryClient()

	return trpc.auth.bankIdentification.useMutation({
		onSuccess: async response => {
			const { accessToken, refreshToken } = response

			await Promise.all([
				Preferences.set({ key: 'accessToken', value: accessToken }),
				Preferences.set({ key: 'refreshToken', value: refreshToken }),
				Preferences.set({
					key: 'authExpire',
					value: encodeBase64(dayjs().add(30, 'minute').toISOString()),
				}),
			])

			await queryClient.invalidateQueries({ queryKey: ['customAccessToken'] })
			await utils.user.currentUser.invalidate()
		},
		onError: error => {
			console.error('Login failed:', error)
		},
	})
}

export default useBankAuth
